import { PixIndicatorCard } from '@1024pix/nebulix-ember';
import { t } from 'ember-intl';

<template>
  <PixIndicatorCard
    @title={{t "cards.participants-average-results.title"}}
    @iconName="awards"
    @color="blue"
    @info={{t "cards.participants-average-results.information"}}
    @isLoading={{@isLoading}}
    class="indicator-card"
    ...attributes
  >
    <:default>{{t "common.result.percentage" value=@value}}</:default>
  </PixIndicatorCard>
</template>
